import { render, staticRenderFns } from "./MatriculaStatus.vue?vue&type=template&id=0403066d&scoped=true"
var script = {}
import style0 from "./MatriculaStatus.vue?vue&type=style&index=0&id=0403066d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0403066d",
  null
  
)

export default component.exports